import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldResource']),
        getByResource: state => resources => 
        {
            return state.objs.filter(u => u.idWorldResource === resources);
        },
        getResourcesByWork: (state, getters, rootState) => workFilter => {
            if(workFilter === 'my') {
                return state.objs;
            } else {
                return state.objs.filter(r=> r.work == workFilter);
            }
        },
        getByType: state => type => 
        {
            return state.objs.filter(r=> r.type === type);
        },
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldResource'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldResource'])
    },
}